import React, { Fragment } from 'react';

import {
  StyledFilter,
  StyledSelect,
  StyledLabel,
  StyledArrow,
} from './styled';

const SelectFilter = ({ label, options, ...controlProps }) => {
  const { name, value } = controlProps;
  const currOptionTitle = value
    && Object(options.find(opt => opt.value === value)).title;
  const labelText = currOptionTitle || label;

  return (
    <StyledFilter>
      <StyledLabel selected={currOptionTitle}>{labelText}</StyledLabel>
      <StyledSelect {...controlProps}>
        {options.map(({ value, title }) => (
          <option value={value}>{title}</option>
        ))}
      </StyledSelect>
      <StyledArrow />
    </StyledFilter>
  );
}

export default SelectFilter;
